import service from "@/utils/request";

// 常用时间列表
interface arrangeTimeListData {
  page?: number;
  page_size?: number;
}
export const arrangeTimeList = (params: arrangeTimeListData) => {
  return service({
    url: "/api/v1/class/arrange/time_list",
    method: "get",
    params,
  });
};
// 常用时间添加
interface createArrangeTimeData {
  start_time: string;
  end_time: string;
}
export const createArrangeTime = (data: createArrangeTimeData) => {
  return service({
    url: "/api/v1/class/arrange/time_add",
    method: "post",
    data,
  });
};
// 常用时间编辑
interface editArrangeTimeData {
  time_id: number;
  start_time: string;
  end_time: string;
}
export const editArrangeTime = (data: editArrangeTimeData) => {
  return service({
    url: "/api/v1/class/arrange/time_edit",
    method: "post",
    data,
  });
};
// 常用时间删除
interface deleteArrangeTimeData {
  time_id: number;
}
export const deleteArrangeTime = (data: deleteArrangeTimeData) => {
  return service({
    url: "/api/v1/class/arrange/time_del",
    method: "post",
    data,
  });
};

// 排课列表
interface arrangeListData {
  class_id: number;
}
export const arrangeList = (params: arrangeListData) => {
  return service({
    url: "/api/v1/class/arrange/list",
    method: "get",
    params,
  });
};
// 规则排课详情
interface arrangeDetailData {
  arrange_id: number;
}
export const arrangeDetail = (params: arrangeDetailData) => {
  return service({
    url: "/api/v1/class/arrange/detail",
    method: "get",
    params,
  });
};
// 添加规则排课
interface createArrangeData {
  class_id: number;
  course_id: number;
  teacher_ids: number[];
  lesson_type: number;
  main_teacher_id: number;
  start_date: string;
  cycle_type: number;
  cycle_step: number;
  end_type: number;
  end_date?: string;
  end_num?: number;
  rules: {
    start_time: string;
    end_time: string;
    week_day?: number;
  }[];
}
export const createArrange = (data: createArrangeData) => {
  return service({
    url: "/api/v1/class/arrange/add",
    method: "post",
    data,
  });
};
// 编辑规则排课
interface editArrangeData {
  class_id: number;
  course_id: number;
  teacher_ids: number[];
  lesson_type: number;
  main_teacher_id: number;
  start_date: string;
  cycle_type: number;
  cycle_step: number;
  end_type: number;
  end_date?: string;
  end_num?: number;
  rules: {
    start_time: string;
    end_time: string;
    week_day?: number;
  }[];
}
export const editArrange = (data: editArrangeData) => {
  return service({
    url: "/api/v1/class/arrange/edit",
    method: "post",
    data,
  });
};
// 删除规则排课
interface deleteArrangeData {
  arrange_id: number;
}
export const deleteArrange = (data: deleteArrangeData) => {
  return service({
    url: "/api/v1/class/arrange/del",
    method: "post",
    data,
  });
};

// 添加日历排课
interface createCalendarArrangeData {
  class_id: number;
  course_id: number;
  teacher_ids: number[];
  lesson_type: number;
  main_teacher_id: number;
  start_time: string;
  end_time: string;
  dates: string[];
}
export const createCalendarArrange = (data: createCalendarArrangeData) => {
  return service({
    url: "/api/v1/class/lesson/add",
    method: "post",
    data,
  });
};

// 排课预计结束时间
interface expectedEndData {
  start_date: number;
  cycle_type: number;
  cycle_step: number;
  end_type: number;
  end_date: number;
  end_num: number;
  rules: {
    start_time: string;
    end_time: string;
    week_day?: number;
  }[];
}
export const expectedEnd = (data: expectedEndData) => {
  return service({
    url: "/api/v1/class/arrange/expected",
    method: "post",
    data,
  });
};
// 排课计划已排除的日期列表
interface excludeDateListData {
  arrange_id: number;
}
export const excludeDateList = (params: excludeDateListData) => {
  return service({
    url: "/api/v1/class/arrange/exclude_date_list",
    method: "get",
    params,
  });
};

// 老师冲突检查
interface teachersWithConflictData {
  class_id: number;
  teacher_ids?: number[];
  arrange_id?: number;
  arrange_rule_args?: {
    start_date: string;
    cycle_type: number;
    cycle_step: number;
    end_type: number;
    end_date: string;
    end_num: number;
    rules: {
      start_time: string;
      end_time: string;
      week_day?: number;
    }[];
  }[];
  lesson_id?: number;
  arrange_date_args?: {
    start_time: string;
    end_time: string;
    dates: string[];
  }[];
}
export const teachersWithConflict = (data: teachersWithConflictData) => {
  return service({
    url: "/api/v1/class/arrange/teachers_with_conflict",
    method: "post",
    data,
  });
};
// 老师选择列表(带冲突检查)
interface teacherSelectListWithConflictData {
  class_id: number;
  page?: number;
  page_size?: number;
  teacher_ids?: number[];
  arrange_id?: number;
  arrange_rule_args?: {
    start_date: string;
    cycle_type: number;
    cycle_step: number;
    end_type: number;
    end_date: string;
    end_num: number;
    rules: {
      start_time: string;
      end_time: string;
      week_day?: number;
    }[];
  }[];
  lesson_id?: number;
  arrange_date_args?: {
    start_time: string;
    end_time: string;
    dates: string[];
  }[];
  name?: string;
}
export const teacherSelectListWithConflict = (
  data: teacherSelectListWithConflictData
) => {
  return service({
    url: "/api/v1/class/arrange/teacher_select_list_with_conflict",
    method: "post",
    data,
  });
};
// 排课冲突检查
interface conflictCheckData {
  class_id: number;
  classroom_id: number;
  teacher_ids?: number[];
  arrange_id?: number;
  arrange_rule_args?: {
    start_date: string;
    cycle_type: number;
    cycle_step: number;
    end_type: number;
    end_date: string;
    end_num: number;
    rules: {
      start_time: string;
      end_time: string;
      week_day?: number;
    }[];
  };
  lesson_id?: number;
  arrange_date_args?: {
    start_time: string;
    end_time: string;
    dates: string[];
  };
}
export const conflictCheck = (data: conflictCheckData) => {
  return service({
    url: "/api/v1/class/arrange/conflict_check",
    method: "post",
    data,
  });
};
// 快速排课冲突检查（新建体验/补课）
export interface quickConflictCheckI {
  start_time: string;
  end_time: string;
  date: string;
  classroom_id?: number;
  teacher_ids: number[];
  student_ids: number[];
}
export const quickConflictCheckApi = (data: quickConflictCheckI) => {
  return service({
    url: "/api/v1/lesson/conflict_check/quick_arrange",
    method: "post",
    data,
  });
};
// 课次冲突检查-课次批量修改上课时间
interface lessonTimeConflictCheckI {
  class_id: number;
  lesson_ids: number[];
  start_time: string;
  end_time: string;
}
export const lessonTimeConflictCheckApi = (data: lessonTimeConflictCheckI) => {
  return service({
    url: "/api/v1/lesson/conflict_check/lesson_batch_edit_time",
    method: "post",
    data,
  });
};
// 课次冲突检查-课次批量修改上课教师
interface lessonTeacherConflictCheckI {
  class_id: number;
  lesson_ids: number[];
  teacher_ids: number[];
}
export const lessonTeacherConflictCheckApi = (
  data: lessonTeacherConflictCheckI
) => {
  return service({
    url: "/api/v1/lesson/conflict_check/lesson_batch_edit_teacher",
    method: "post",
    data,
  });
};
// 课次冲突检查-课次批量修改上课教室
interface lessonClassroomConflictCheckI {
  class_id: number;
  lesson_ids: number[];
  classroom_id: number;
}
export const lessonClassroomConflictCheckApi = (
  data: lessonClassroomConflictCheckI
) => {
  return service({
    url: "/api/v1/lesson/conflict_check/lesson_batch_edit_classroom",
    method: "post",
    data,
  });
};
// 课次冲突检查-课次学员添加(临时/体验/补课)
interface lessonStudentConflictCheckI {
  lesson_id: number;
  student_ids: number[];
}
export const lessonStudentConflictCheckApi = (
  data: lessonStudentConflictCheckI
) => {
  return service({
    url: "/api/v1/lesson/conflict_check/lesson_student_add",
    method: "post",
    data,
  });
};
// 课次冲突检查-班级学员变更(入班/换班)
interface studentChangeConflictCheckI {
  original_class_id?: number;
  join_class_id: number;
  student_ids: number[];
}
export const studentChangeConflictCheckApi = (
  data: studentChangeConflictCheckI
) => {
  return service({
    url: "/api/v1/lesson/conflict_check/class_student_change",
    method: "post",
    data,
  });
};
// 课次冲突检查-按天调课
export const conflictCheckLessonMoveByDataApi = (data: {
  date: string;
  new_date: string;
}) => {
  return service({
    url: "/api/v1/lesson/conflict_check/lesson_move_by_data",
    method: "post",
    data,
  });
};
